import { EnvFactory } from "./EnvFactory";

export const GOOGLE_PLACES_DEBOUNCE = 500;

export const APP_NAME = "Showpass";
export const IS_REACT_NATIVE_APP = "is-react-native-app";
export const X_SP_UUID = "x-sp-uuid";
export const X_SP_ANALYTICS_SIGNATURE = "X-SP-ANALYTICS-SIGNATURE";

const API_URL = EnvFactory.getValue("SHOWPASS_API_URL");
const APP_ENV = EnvFactory.getValue("APP_ENV");
const CDN_URL = EnvFactory.getValue("CDN_URL");
const IMAGE_CDN_URL = EnvFactory.getValue("IMAGE_CDN_URL");
const MEDIA_CDN_URL = EnvFactory.getValue("MEDIA_CDN_URL");
const INTERNAL_SHOWPASS_API_URL = EnvFactory.getValue(
  "INTERNAL_SHOWPASS_API_URL"
);
const NODE_ENV = EnvFactory.getValue("NODE_ENV");
const PLATFORM = EnvFactory.getValue("PLATFORM");
const SITE_URL = EnvFactory.getValue("SITE_URL");
const STATE_TOKEN_SECRET_KEY = EnvFactory.getValue("STATE_TOKEN_SECRET_KEY");
const STATIC_FILE_PATH = EnvFactory.getValue("STATIC_FILE_PATH");
const STORYBOOK_PLATFORM = EnvFactory.getValue("STORYBOOK_PLATFORM");

// Analytics
const ADWORDS_GLOBAL_TAG = EnvFactory.getValue("ADWORDS_GLOBAL_TAG");
const FACEBOOK_TRACKING_PIXEL = EnvFactory.getValue("FACEBOOK_TRACKING_PIXEL");
const GOOGLE_ANALYTICS_4_TRACKING_ID = EnvFactory.getValue(
  "GOOGLE_ANALYTICS_4_TRACKING_ID"
);
const GOOGLE_PLACES_API_KEY = EnvFactory.getValue("GOOGLE_PLACES_API_KEY");
const GOOGLE_TAG_MANAGER_CONTAINER_ID = EnvFactory.getValue(
  "GOOGLE_TAG_MANAGER_CONTAINER_ID"
);
const SHOWPASS_ANALYTICS_SIGNATURE_KEY = EnvFactory.getValue(
  "SHOWPASS_ANALYTICS_SIGNATURE_KEY"
);

const ROKT_ACCOUNT_ID = EnvFactory.getValue("ROKT_ACCOUNT_ID");

const SENTRY_DSN = EnvFactory.getValue("SENTRY_DSN");
const ENABLE_SENTRY = EnvFactory.getValue("ENABLE_SENTRY");

// Newsletter
const NEWSLETTER_MID = EnvFactory.getValue("NEWSLETTER_MID");
const NEWSLETTER_LID = EnvFactory.getValue("NEWSLETTER_LID");
const NEWSLETTER_ACTION_URL = EnvFactory.getValue("NEWSLETTER_ACTION_URL");
const NEWSLETTER_THX_URL = EnvFactory.getValue("NEWSLETTER_THX_URL");
const NEWSLETTER_ERR_URL = EnvFactory.getValue("NEWSLETTER_ERR_URL");

// CACHE
const CACHE_URL = EnvFactory.getValue("CACHE_URL");
const EVENT_PAGE_CACHE_URL = EnvFactory.getValue("EVENT_PAGE_CACHE_URL");

const DD_RUM_ENABLED = EnvFactory.getValue("DD_RUM_ENABLED");
const DD_APP_ID = EnvFactory.getValue("DD_APP_ID");
const DD_CLIENT_TOKEN = EnvFactory.getValue("DD_CLIENT_TOKEN");
const DD_SITE = EnvFactory.getValue("DD_SITE");
const DD_SERVICE = EnvFactory.getValue("DD_SERVICE");
const DD_ENV = EnvFactory.getValue("DD_ENV");
const APP_VERSION = EnvFactory.getValue("APP_VERSION");
const DD_SESSION_SAMPLE_RATE = EnvFactory.getValue("DD_SESSION_SAMPLE_RATE");
const DD_SESSION_REPLAY_SAMPLE_RATE = EnvFactory.getValue(
  "DD_SESSION_REPLAY_SAMPLE_RATE"
);
const DD_TRACK_USER_INTERACTIONS = EnvFactory.getValue(
  "DD_TRACK_USER_INTERACTIONS"
);
const DD_TRACK_RESOURCES = EnvFactory.getValue("DD_TRACK_RESOURCES");
const DD_TRACK_LONG_TASKS = EnvFactory.getValue("DD_TRACK_LONG_TASKS");

// Protecht
const PROTECHT_API_KEY = EnvFactory.getValue("PROTECHT_API_KEY");

export {
  API_URL,
  APP_ENV,
  CDN_URL,
  IMAGE_CDN_URL,
  MEDIA_CDN_URL,
  INTERNAL_SHOWPASS_API_URL,
  NODE_ENV,
  PLATFORM,
  SITE_URL,
  STATE_TOKEN_SECRET_KEY,
  STATIC_FILE_PATH,
  STORYBOOK_PLATFORM,
  // Analytics
  ADWORDS_GLOBAL_TAG,
  FACEBOOK_TRACKING_PIXEL,
  GOOGLE_ANALYTICS_4_TRACKING_ID,
  GOOGLE_PLACES_API_KEY,
  GOOGLE_TAG_MANAGER_CONTAINER_ID,
  SHOWPASS_ANALYTICS_SIGNATURE_KEY,
  // Newsletter
  NEWSLETTER_MID,
  NEWSLETTER_LID,
  NEWSLETTER_ACTION_URL,
  NEWSLETTER_THX_URL,
  NEWSLETTER_ERR_URL,

  // Rokt
  ROKT_ACCOUNT_ID,

  // CACHE
  CACHE_URL,
  EVENT_PAGE_CACHE_URL,

  // Sentry
  SENTRY_DSN,
  ENABLE_SENTRY,

  // Datadog Rum
  DD_RUM_ENABLED,
  DD_APP_ID,
  DD_CLIENT_TOKEN,
  DD_SITE,
  DD_SERVICE,
  DD_ENV,
  APP_VERSION,
  DD_SESSION_SAMPLE_RATE,
  DD_SESSION_REPLAY_SAMPLE_RATE,
  DD_TRACK_USER_INTERACTIONS,
  DD_TRACK_RESOURCES,
  DD_TRACK_LONG_TASKS,

  // Protecht
  PROTECHT_API_KEY,
};
